import { ReactNode } from 'react';
import * as React from 'react';
import { Box } from 'reflexbox';
// eslint-disable-next-line import/no-unresolved
import CSS from 'csstype';

type ResponsiveValue<T> = T | Array<T>;

type ReflexDimension = number | string;

interface ISpacingProps {
	p?: ResponsiveValue<ReflexDimension>;
	px?: ResponsiveValue<ReflexDimension>;
	py?: ResponsiveValue<ReflexDimension>;
	pt?: ResponsiveValue<ReflexDimension>;
	pb?: ResponsiveValue<ReflexDimension>;
	my?: ResponsiveValue<ReflexDimension>;
	mx?: ResponsiveValue<ReflexDimension>;
	mt?: ResponsiveValue<ReflexDimension>;
	mr?: ResponsiveValue<ReflexDimension>;
	ml?: ResponsiveValue<ReflexDimension>;
	mb?: ResponsiveValue<ReflexDimension>;
}

interface IProps extends ISpacingProps {
	children: ReactNode;
	visual?: boolean;

	width?: ResponsiveValue<number>;
	textAlign?: ResponsiveValue<CSS.Property.TextAlign>;
	display?: ResponsiveValue<CSS.Property.Display>;
	alignSelf?: ResponsiveValue<CSS.Property.AlignSelf>;
	justifySelf?: ResponsiveValue<CSS.Property.JustifySelf>;
	flex?: ResponsiveValue<CSS.Property.Flex<string>>;

	// Adds default padding-x for grid columns
	spaced?: boolean;
	className?: string;
	style?: React.CSSProperties;
}

export default function Column({
	children,
	visual,

	width,
	textAlign,
	display,
	alignSelf,
	justifySelf,
	flex,

	p,
	px,
	py,
	pt,
	pb,
	my,
	mx,
	mt,
	mr,
	ml,
	mb,

	spaced,

	className,
	style = {},
}: IProps) {
	const givenProps: Record<string, ResponsiveValue<ReflexDimension> | undefined> = {
		p,
		px,
		py,
		pt,
		pb,
		my,
		mx,
		mt,
		mr,
		ml,
		mb,
	};

	const filledProps = Object.keys(givenProps).reduce((result, propKey) => {
		const value = givenProps[propKey];

		// If property spaced is passed, a default padding-x will be applied
		if (propKey === 'px' && spaced === true) {
			return { ...result, mx: [1, 1, 2] };
		}

		if (value != null) {
			return { ...result, [propKey]: value };
		}

		return result;
	}, {});

	let mutableStyle = { ...style };
	if (visual === true) {
		mutableStyle = {
			...mutableStyle,
			backgroundColor: 'rgba(233, 46, 54, 0.8)',
		};
	}

	return (
		<Box
			width={width}
			textAlign={textAlign}
			display={display}
			flex={flex}
			alignSelf={alignSelf}
			justifySelf={justifySelf}
			style={mutableStyle}
			className={className}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...filledProps}
		>
			{children}
		</Box>
	);
}
